import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { AppComponent } from "./components/app.component";
import { LoginComponent } from "./components/login/login.component";
import { NotfoundComponent } from "./components/notfound/notfound.component";
import { BsrmhttpService } from "./services/bsrmhttp.service";

import { Authdata } from "./classes/authdata.class";
import {
  DxTextBoxModule,
  DxValidatorModule,
  DxButtonModule,
  DxLoadPanelModule,
} from "devextreme-angular";
import { RedirectComponent } from "./components/redirect/redirect.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FileProcessingService } from "./services/file-processing.service";
import { GlobalService } from "./services/global.service";
import { SecurityInterceptor } from "./interceptors/security-interceptor";
import { ResponseInterceptor } from "./interceptors/response-interceptor";
import { BsrmencryptionService } from "./services/bsrmencryption.service";
import { ResetpasswordComponent } from "./components/resetpassword/resetpassword.component";
import { ForgotpasswordComponent } from "./components/forgotpassword/forgotpassword.component";
import { orderDetailsResolver } from "./cvrs/order-details.resolver";
import { ChangepasswordComponent } from "./users/components/changepassword/changepassword.component";
import { vrsDetailsResolver } from "./cvrs/vrs-details.resolver";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NotfoundComponent,
    RedirectComponent,
    ResetpasswordComponent,
    ForgotpasswordComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxButtonModule,
    DxLoadPanelModule,
    HttpClientModule,
    RouterModule.forRoot(
      [
        {
          path: "dashboard",
          loadChildren: () =>
            import("./mobile-view/mobile-view.module").then(
              (m) => m.MobileViewModule
            ),
        },
        {
          path: "login",
          component: LoginComponent,
        },
        {
          path: "forgotpassword",
          component: ForgotpasswordComponent,
        },
        {
          path: "redirect",
          component: RedirectComponent,
        },
        {
          path: "recovery",
          loadChildren: () =>
            import("./password-recovery/password-recovery.module").then(
              (m) => m.PasswordRecoveryModule
            ),
        },
        {
          path: "crm",
          loadChildren: () =>
            import("./container/container.module").then(
              (m) => m.ContainerModule
            ),
        },
        // {
        //   path: "forgetpassword"
        //   ,component : ForgetpassComponent
        // },
        {
          path: "resetpassword",
          component: ResetpasswordComponent,
        },
        {
          path: "changepassword",
          component: ChangepasswordComponent,
        },
        //   {
        //   path: "app"
        //   ,component: ApplicationComponent

        // },
        // {
        //   path: "security"
        //   ,component: DashboardComponent
        //   ,loadChildren: "./security/security.module#SecurityModule"
        // },
        // {
        //   path: "crm"
        //   ,component: DashboardComponent
        //   ,loadChildren: "./operational-form/operational-form.module#OperationalFormModule"
        // },
        // {
        //   path: "reports"
        //   ,component: DashboardComponent
        //   ,loadChildren: "./report/report.module#ReportModule"

        // },
        {
          path: "",
          pathMatch: "full",
          component: LoginComponent,
        },
        {
          path: "**",
          component: NotfoundComponent,
        },
      ],
      { useHash: true }
    ),
  ],
  providers: [
    GlobalService,
    FileProcessingService,
    BsrmhttpService,
    BsrmencryptionService,
    orderDetailsResolver,
    vrsDetailsResolver,
    Authdata,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SecurityInterceptor,
      multi: true,
    },
    // ,{
    //   provide : HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true
    // }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
